import React, { useState } from 'react';
import { PromotionsContent } from '../components/promotionsContent';
import { ScriptContent } from '../components/scriptContent';
import '../styles/stages.css';
import SEO from '../components/SEO';
import { baseUrl } from '../config';



export function PostStages() {
  const [openModal, setOpenModal] = useState(false);
  const [ModalComponent, setModalComponent] = useState(null);

  // Function to handle card clicks and update modal content
  function handleCardClick(Component) {
    setModalComponent(() => Component);
    setOpenModal(true);
  }

  function handleCloseModal() {
    setOpenModal(false);
    setModalComponent(null);
  }

  return (
    <div className="relative">
      <SEO
        title="Post-Production Stages"
        description="Select your film's post-production stages to customise your ProducerBuddy workflow for editing, sound, VFX, and delivery."
        url="https://producerbuddy.pilomation.com/post-stages"
        robots="noindex, nofollow"
      />
      <div className="stages_content mt-5">
        <h5 className="bg-gradient-to-r from-purple-700 to-gray-800 text-transparent bg-clip-text">
          Choose the stages of post-production
        </h5>
        <div className="stages_cards flex gap-8 overflow-hidden">
          <div className="stages_card cursor-pointer" onClick={() => handleCardClick(ScriptContent)}>
            <h2>Market analysis +</h2>
          </div>
          <div className="stages_card cursor-pointer" onClick={() => handleCardClick(PromotionsContent)}
            
            >
            <h2>Promotions +</h2>
          </div>
        </div>
        <div className="stages_cards flex gap-8 overflow-hidden">
          <div
            className="stages_card cursor-pointer"
            
          >
            <h2>Posters +</h2>
          </div>
          <div
            className="stages_card cursor-pointer"
            
          >
            <h2>Trailers +</h2>
          </div>
        </div>
        <div className="stages_cards flex gap-8 overflow-hidden">
          <div
            className="stages_card cursor-pointer"
            
          >
            <h2>Advertisements +</h2>
          </div>
        </div>
      </div>
      <div className="stages_button mt-4 flex items-center justify-evenly">
        <button className="btn btn-secondary py-2 px-4 rounded-md bg-gray-500 text-white" type="button">Skip</button>
        <button className="btn btn-primary py-2 px-4 rounded-md bg-blue-500 text-white" type="button">Continue</button>
      </div>

      {/* Modal */}
      {openModal && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg relative max-w-4xl max-h-[80vh] overflow-auto">
            <button
              onClick={handleCloseModal}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
            >
              &times;
            </button>
            {ModalComponent && <ModalComponent />}
          </div>
        </div>
      )}
    </div>
  );
}

